"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.esCompanyNumberChecker = exports.NIE_REGEX = exports.LEGAL_ENTITY_NIF_REGEX = exports.LEGAL_ENTITY_CONTROL_LETTERS = exports.DNI_REGEX = exports.DNI_CONTROL_LETTERS = void 0;
/*
 * ---------- LEGAL ENTITY PERSON ----------
 */
var LEGAL_ENTITY_CONTROL_LETTERS = exports.LEGAL_ENTITY_CONTROL_LETTERS = 'JABCDEFGHI';
var LEGAL_ENTITY_NIF_REGEX = exports.LEGAL_ENTITY_NIF_REGEX = /^[ABCDEFGHJNPQRSUVW]\d{7}[\dA-J]$/i;
var HAS_CONTROL_LETTER_REGEX = /^[PQRSW]/;
var HAS_CONTROL_LETTER_IDENTIFIER = '00';
var HAS_CONTROL_NUMBER_REGEX = /^[ABEH]/;
var sumEvenPositions = function sumEvenPositions(legalEntityNumbers) {
  return +legalEntityNumbers[1] + +legalEntityNumbers[3] + +legalEntityNumbers[5];
};
var calculateOddPosition = function calculateOddPosition(num) {
  var doubledNum = num * 2;
  if (doubledNum < 10) return doubledNum;
  var splittedNum = "".concat(doubledNum).split('');
  return +splittedNum[0] + +splittedNum[1];
};
var calculateOddPositions = function calculateOddPositions(legalEntityNumbers) {
  return calculateOddPosition(+legalEntityNumbers[0]) + calculateOddPosition(+legalEntityNumbers[2]) + calculateOddPosition(+legalEntityNumbers[4]) + calculateOddPosition(+legalEntityNumbers[6]);
};
var getLegalEntityNumbers = function getLegalEntityNumbers(legalEntityNif) {
  return legalEntityNif.slice(1, -1);
};
var getLegalEntityNifControlNumber = function getLegalEntityNifControlNumber(nif) {
  var legalEntityNumbers = getLegalEntityNumbers(nif);
  var keyNumber = +"".concat(sumEvenPositions(legalEntityNumbers) + calculateOddPositions(legalEntityNumbers)).slice(-1);
  return keyNumber === 0 ? keyNumber : 10 - keyNumber;
};
var isControlCodeLetter = function isControlCodeLetter(legalEntityNif) {
  return HAS_CONTROL_LETTER_REGEX.test(legalEntityNif) || legalEntityNif[0] === HAS_CONTROL_LETTER_IDENTIFIER;
};
var isControlCodeNumber = function isControlCodeNumber(legalEntityNif) {
  return HAS_CONTROL_NUMBER_REGEX.test(legalEntityNif);
};

/**
 * Checks if the legal entity nif control code (letter or number)
 * provided is valid.
 *
 * @WARNING It does not check the `LEGAL_ENITY_NIF_REGEX`.
 * @throws May throw an error if the string is not long enough (9 characters)
 * @param legalEntityNif
 * @returns
 */
function isValidLegalEntityNifControlCode(legalEntityNif) {
  var controlCodeToVerify = legalEntityNif.slice(-1);
  var controlNumber = getLegalEntityNifControlNumber(legalEntityNif);
  if (isControlCodeLetter(legalEntityNif)) return LEGAL_ENTITY_CONTROL_LETTERS[controlNumber] === controlCodeToVerify;
  if (isControlCodeNumber(legalEntityNif)) return controlNumber === +controlCodeToVerify;
  return Number.isNaN(+controlCodeToVerify) ? LEGAL_ENTITY_CONTROL_LETTERS[controlNumber] === controlCodeToVerify : controlNumber === +controlCodeToVerify;
}

/**
 * Checks if the legalEntityNif provided is valid.
 *
 * It does not include old K, L and M formats.
 * @param legalEntityNif
 * @returns true for valid input and false for invalid input.
 */
function isValidLegalEntityNif(legalEntityNif) {
  return LEGAL_ENTITY_NIF_REGEX.test(legalEntityNif) && isValidLegalEntityNifControlCode(legalEntityNif);
}

/*
 * ---------- NATURAL ENTITY PERSON ----------
 */
var NIE_REGEX = exports.NIE_REGEX = /^[XYZ]\d{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
var DNI_REGEX = exports.DNI_REGEX = /^([KLM]\d{7}|\d{8})[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
var DNI_CONTROL_LETTERS = exports.DNI_CONTROL_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE';

/**
 * Checks if the dni control code (letter) provided is valid.
 *
 * It does include checks for DNI K, L and M.
 * @WARNING It does not check the `DNI_REGEX`.
 * @param dni
 * @returns true for valid input and false for invalid input.
 */
function isValidDniLetter(dni) {
  var letterIndex = +dni.replace(/\D/g, '') % 23;
  var letter = dni.slice(-1);
  return DNI_CONTROL_LETTERS.charAt(letterIndex) === letter;
}

/**
 * Returns a new string with the nie letter (XYZ) replaced.
 * However it will throw an error if the first character is not X, Y or Z.
 * @throws Invalid NIE letter error
 * @param nie
 * @returns A new string with the nie letter (XYZ) replaced.
 */
function replaceNieLetter(nie) {
  var nieLetter = nie.charAt(0).toUpperCase();
  if (nieLetter === 'X') return 0 + nie.substring(1);
  if (nieLetter === 'Y') return 1 + nie.substring(1);
  if (nieLetter === 'Z') return 2 + nie.substring(1);
  throw new Error('Invalid NIE letter');
}

/**
 * Checks if the given nie is valid.
 * @param nie
 * @returns true for valid input and false for invalid input.
 */
function isValidNie(nie) {
  try {
    return NIE_REGEX.test(nie) && isValidDniLetter(replaceNieLetter(nie));
  } catch (err) {
    // eslint-disable-line @typescript-eslint/no-unused-vars
    return false;
  }
}

/**
 * Checks if the given dni is valid.
 *
 * It does include checks for DNI K, L and M.
 * @param dni
 * @returns true for valid input and false for invalid input.
 */
function isValidDni(dni) {
  return DNI_REGEX.test(dni) && isValidDniLetter(dni);
}

/**
 * Checks if the given naturalPersonNif is whether a valid DNI (including DNI K, L and M) or a valid NIE.
 * @param naturalPersonNif
 * @returns true for valid input and false for invalid input.
 */
function isValidNaturalPersonNif(naturalPersonNif) {
  return isValidDni(naturalPersonNif) || isValidNie(naturalPersonNif);
}

/*
 * ---------- FINAL CHECKER ----------
 */
/**
 * Checks if the given nif (legal entity NIF or natural person NIF
 * (DNI, DNI K, DNI L, DNI M, or NIE)) is valid.
 *
 * @returns true for valid input and false for invalid input.
 * @param companyNumber
 */
var esCompanyNumberChecker = exports.esCompanyNumberChecker = function esCompanyNumberChecker(companyNumber) {
  return isValidNaturalPersonNif(companyNumber) || isValidLegalEntityNif(companyNumber);
};